import { LeadCardType, CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import type { CardSettings } from 'cards/types/cardSettings';
import { SETTINGS_BY_CARD_TYPE } from 'cards/constants/settingsByCardType';

export const getCardSettings = (cardType?: LeadCardType, isDigital?: boolean): CardSettings => {
  if (isDigital) {
    return SETTINGS_BY_CARD_TYPE[CARD_TYPE_MAP.dstd];
  }
  if (cardType && SETTINGS_BY_CARD_TYPE[cardType]) {
    return SETTINGS_BY_CARD_TYPE[cardType];
  }
  // @ts-expect-error We should have a guard against cardType not being defined or define this function to return CardSettings or an empty object
  return {};
};
